module.exports = require("./dua-CM.js");